<template>
  <TransactionListTemplate
    :screen-config="setScreenConfig"
    :row-click="rowClickCallBack"
    persistence-key="maintenance-order-draft-list"
    :setLoading="setLoading"
    ref="maintenance-order-draft-list"
  >
    <template #popup>
      <GcPopupMaintenanceOrder
        :popupConfig="popup"
        :on-hide="onPopupHide"
        :wrapper-attr="{
          class: 'css-v2 gc-popup gc-popup-form gc-popup-work-order',
        }"
        :data-model="dataModel"
        :show-loading="ShowLoading"
        :width="1024"
        :height="370"
        :save-call-back="onWorkOrderSave"
        :displayServerError="displayServerErrorOnTemplate"
        v-if="popup.isPopupShow"
      />
    </template>
  </TransactionListTemplate>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";

import TransactionListTemplate from "@/templates/transaction-list";
import { FeatureStorage } from "@/_services/storage";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
import { WorkOrderService } from "@/_services/api/production/work-order.service";
import {
  GetIndexByTabName,
  MaintenanceOrderTabs,
} from "../../../_models/tabdata/production/maintenance-order-tabs";
import GcPopupMaintenanceOrder from "../../../popups/maintenance-order/gc-popup-maintenance-order";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {
    TransactionListTemplate,
    GcPopupMaintenanceOrder,
  },
  data() {
    return {
      transactionListKey: 0,
      model: {
        BomCode: null,
        Branch: null,
        QuoteCode: 0,
        Code: 0,
        Comments: "",
        CompanyCode: "",
        Division: null,
        Product: null,
        Quantity: 0,
        Required: new Date(),
        Scheduled: new Date(),
        DateIn: new Date(),
      },
      initialModel: null, // To store the initial state
      popup: {
        title: "",
        secondaryTitle: undefined,
        isFormLoading: false,
        popupKey: 0,
        formKey: 0,
        height: 370,
        isPopupShow: false,
        hideOnOutsideClick: false,
        // toolbarMenuItems: [
        //   {
        //     menuText: "Copy",
        //     visible: false, // pending discussions #54331
        //   },
        //   { menuText: "Cancel", onClick: this.onCancelWorkOrderHandler },
        //   { menuText: "Reopen", onClick: this.onReopenWorkOrderHandler },
        //   { menuText: "Complete", onClick: this.onCompleteWorkOrderHandler },
        // ],
        formMode: "create",
        isEditable: false,
      },
      setLoading: false,
      dataModel: undefined,
    };
  },
  computed: {
    setScreenConfig() {
      return {
        title: "Maintenance Orders",
        ScreenName: "Maintenance Orders",
        exportFileName: "Maintenance Order List - Draft",
        selectedIndex: GetIndexByTabName("Draft"),
        tabs: MaintenanceOrderTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "WorkOrderList",
              filter: [
                ["FriendlyStatus", "=", "Draft"],
                "and",
                ["WOType", "=", "Maintenance"],
              ],
              serverPaging: true,
              allowGrouping: false,
              select: [
                "BomCode",
                "BomDescription",
                "ChangedBy",
                "Code",
                "CreatedBy",
                "DateChanged",
                "DateCreated",
                "FriendlyStatus",
                "ItemQty",
                "ProductCode",
                "ProductDescription",
                "ProductDescription1",
                "ProductDescription2",
                "SalesOrderList",
                "ScheduledDate",
                "ShipDate",
                "Status",
                "BranchCode",
                "WOType",
                "Comment",
              ],
              keyType: {
                ...this.getAttributeKeyTypes(),
              },
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Maintenance Order",
                message: "Get Started, Add a Maintenance Order",
              },
            },
            options: {
              selectionMode: "multiple",
            },
          },
          toolbar: {
            screenName: "Maintenance Orders",
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            multiplePdf: true,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                clickAction: this.onNewWorkOrderHandler,
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission(
                  "MaintenanceOrder",
                  "create"
                ),
              },
            ],
          },
          columns: [
            {
              screenField: "Code",
              filterLabel: "Maintenance Order",
              label: "Maintenance Order",
              gridDataField: "Code",
              sortOrder: "desc",
              filterIndex: 1,
              type: "Integer",
              sortIndex: 0,
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              minWidth: ColumnWidth.PurchaseOrderCode.minWidth,
              width: ColumnWidth.PurchaseOrderCode.width,
              // forceWidth: true,
            },
            {
              screenField: "BOM",
              label: "BOM",
              filterIndex: 2,
              allowHiding: false,
              filterOverWrites: {
                select: [
                  "BomTypeCode",
                  "Status",
                  "Code",
                  "ProductCode",
                  "Description1",
                ],
                filter: [
                  ["Status", "=", "A"],
                  "and",
                  ["BomTypeCode", "=", "Maintenance"],
                ],
              },
            },
            {
              screenField: "DateIn",
              dataField: "ScheduledDate",
              filterDataField: "ScheduledDate",
              filterLabel: "Scheduled Date",
              label: "Scheduled",
              filterIndex: 3,
              minWidth: ColumnWidth.Date.minWidth,
              width: ColumnWidth.Date.width,
            },
            {
              screenField: "Comments",
              customizeText: (e) => {
                if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
                else return "";
              },
              encodeHtml: false,
              cellTemplate: (data, info) => {
                return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
              },
              filterIndex: 4,
              dataType: "string",
              type: "Text",
              textOperators: true,
              dataField: "Comment",
              filterDataField: "Comment",
            },
            {
              screenField: "Status",
              gridDataField: "FriendlyStatus",
              dataField: "FriendlyStatus",
              filterDataField: "FriendlyStatus",
              label: "",
              cellTemplate: "Status",
              fixed: true,
            },
            {
              screenField: "GridRecordPrint",
              cssClass: "padding-7",
              ReferenceNoField: "Code",
            },
            {
              screenField: "GridRecordPDFView",
              cssClass: "padding-7",
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  return [
                    {
                      menuText: "Copy",
                      data: data,
                      clickAction: this.onCopyWorkOrderHandler,
                      visible: true, // pending discussions #54331
                    },
                    {
                      menuText: "Cancel",
                      data: data,
                      clickAction: this.onCancelWorkOrderHandler,
                      disabled:
                        data.data.FriendlyStatus !== "Active" &&
                        data.data.FriendlyStatus !== "Draft",
                    },
                    {
                      menuText: "Reopen",
                      data: data,
                      clickAction: this.onReopenWorkOrderHandler,
                      disabled:
                        data.data.FriendlyStatus !== "Completed" &&
                        data.data.FriendlyStatus !== "Cancelled",
                      visible: false, // hide for now as draft orders are not re-openable
                    },
                    {
                      menuText: "Complete",
                      data: data,
                      clickAction: this.onCompleteWorkOrderHandler,
                      disabled: data.data.FriendlyStatus !== "In Production",
                      visible: false, // hide for now as draft orders are not completable
                    },
                  ];
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              makeDisabled: () => {
                return !FeatureStorage.checkPermission("MaintenanceOrder", "create");
              },
            },
          ],
        },
      };
    },
  },
  created() {},
  methods: {
    /**
     * Show Loading
     * @param value
     * @constructor
     */
    ShowLoading(value) {
      this.setLoading = value;
    },
    /**
     * Hide A popup
     */
    onPopupHide() {
      this.popup.isPopupShow = false;
    },

    onWorkOrderSave() {
      this.onPopupHide();
      this.showLoading(true);
      this.$refs["maintenance-order-draft-list"].$refs[
        "transactionListGrid"
      ].gridRepaint();
    },

    /**
     * On New Maintenance Order Handler
     */
    async onNewWorkOrderHandler() {
      this.popup.title = "Create Maintenance Order";
      this.showPopupModal();

      this.popup.hideOnOutsideClick = false;
      this.popup.formMode = "create";
    },

    /**
     * On Copy Maintenance Order
     * @param data
     * @param grid
     */
    async onCopyWorkOrderHandler(data) {
      this.popup.title = "Create Maintenance Order";

      this.popup.hideOnOutsideClick = false;

      const response = await WorkOrderService.getByCode(data.Code);
      const workOrderDetail = response.data.value[0];
      this.dataModel = workOrderDetail;
      this.dataModel.FriendlyStatus = "Draft";
      this.dataModel.Status = "D";
      this.dataModel.Code = 0;
      this.dataModel.QuoteCode = 0;

      this.popup.workOrderCode = workOrderDetail.Code;
      this.popup.isEditable = FeatureStorage.checkPermission(
        "MaintenanceOrder",
        "create"
      );

      this.popup.formMode = "copy";

      this.showPopupModal();
    },

    /**
     * On Cancel Maintenance Order
     * @param data
     * @param grid
     */
    async onCancelWorkOrderHandler(data, grid) {
      let confirmCancel = await this.$confirm(
        "Do you want to cancel this maintenance order?",
        "Cancel Maintenance Order"
      );

      if (confirmCancel) {
        this.onPopupHide();
        this.setLoading = true;
        await WorkOrderService.cancelWorkOrder({
          Code: data.Code.toString(),
          DateChanged: new Date().toISOString().replace("Z", ""),
        })
          .then((res) => {
            this.$notify(
              `Maintenance Order #${data.Code} Successfully Cancelled`,
              "success"
            );
            this.setLoading = false;
            if (res) grid.refresh();
          })
          .catch((err) => {
            this.setLoading = false;
            this.$store.dispatch("ui/setServerError", {
              error: err,
              title: "Cancel Maintenance Order Failed",
            });
          });
      }
    },
    /**
     * On Reopen Maintenance Order Handler
     * @param data
     * @param grid
     */
    async onReopenWorkOrderHandler(data, grid) {
      let confirmReOrder = await this.$confirm(
        "Do you want to re-open this maintenance order?",
        "Re-Open Maintenance Order"
      );

      if (confirmReOrder) {
        this.onPopupHide();
        this.setLoading = true;
        await WorkOrderService.reopenWorkOrder({
          Code: data.Code.toString(),
          DateChanged: new Date().toISOString().replace("Z", ""),
        })
          .then((res) => {
            this.$notify(
              `Maintenance Order #${data.Code} Successfully Re-Opened.`,
              "success"
            );
            this.setLoading = false;
            if (res) grid.refresh();
          })
          .catch((err) => {
            this.setLoading = false;
            this.$store.dispatch("ui/setServerError", {
              error: err,
              title: "Re-Open Maintenance Order Failed",
            });
          });
      }
    },
    /**
     * On Complete Maintenance Order Handler
     * @param data
     * @param grid
     */
    async onCompleteWorkOrderHandler(data, grid) {
      let confirmComplete = await this.$confirm(
        "Do you want to complete this maintenance order?",
        "Complete Maintenance Order"
      );

      if (confirmComplete) {
        this.onPopupHide();
        this.setLoading = true;
        await WorkOrderService.completeWorkOrder({
          Code: data.Code.toString(),
          DateChanged: new Date().toISOString().replace("Z", ""),
        })
          .then((res) => {
            this.$notify(
              `Maintenance Order #${data.Code} Successfully Completed`,
              "success"
            );
            this.setLoading = false;
            if (res) grid.refresh();
          })
          .catch((err) => {
            this.setLoading = false;
            this.$store.dispatch("ui/setServerError", {
              error: err,
              title: "Complete Maintenance Order Failed",
            });
          });
      }
    },

    displayServerErrorOnTemplate(err, msg) {
      this.$store.dispatch("ui/setServerError", {
        error: err,
        title: msg,
      });
    },
    /**
     * Show Popup Modal
     */
    showPopupModal() {
      this.popup.popupKey++;
      this.popup.isPopupShow = true;
    },

    /**
     * Show Modal Review
     */
    showModalReview() {
      this.popup.hideOnOutsideClick = true;
      this.popup.formMode = "review";
      this.showPopupModal();
    },
    /**
     * On Row Click CallBack
     * @param e
     */
    async rowClickCallBack(e) {
      if (
        e.rowType === "data" &&
        e.column.screenField !== "Status" &&
        e.column.screenField !== "GridRecordPDFView" &&
        e.column.screenField !== "GridRecordEllipsisMenu" &&
        e.column.screenField !== "GridRecordPrint" &&
        e.column.type !== "selection"
      ) {
        const response = await WorkOrderService.getByCode(e.data.Code);
        const workOrderDetail = response.data.value[0];
        this.dataModel = workOrderDetail;
        this.dataModel.FriendlyStatus = e.data.FriendlyStatus;

        this.popup.title = `Maintenance Order #${workOrderDetail.Code}`;
        this.popup.workOrderCode = workOrderDetail.Code;
        this.popup.secondaryTitle =
          e.data.ProductCode + " - " + e.data.ProductDescription;

        this.showModalReview();
      }
    },
  },
};
</script>

<style lang="scss"></style>
